import { grey, blue, red, green } from "@material-ui/core/colors"

const colors = {
  white: "#ffffff",
  black: "#1e1e1e",
  lightblue: "#d1d6e1",
  blue: "#2076bc",
  darkblue: "#173755",
  duckBlue: "#1c313a",
  gold: "#d3a03e",
  lightgold: "#e7c076",
  darkGray: "#373e47",
  gray: "#828282",
  lightGray: "#eaebf2"
}

/**
 * Global application theme for Montaigne
 *
 * D A N G E R   Z O N E:
 * When you non standard properties are added make sure they are all applied to others themes plugin.
 *
 * See:
 *  > https://material-ui.com/customization/default-theme/
 *  > https://material-ui.com/customization/theming/
 */
const appTheme = {
  palette: {
    tableHead: {
      backgroundColor: colors.darkGray,
      color: colors.lightgold
    },
    table: {
      border: colors.lightgold
    },
    common: {
      white: colors.white,
      whiteCream: "#fcfcfc",
      lightGray: colors.lightGray,
      lightRose: red[500],
      lightGreen: green[500],
      gray: colors.gray,
      black: colors.black,
      appBar: colors.white,
      cardHeaderBg: colors.darkGray,
      tabBgSelected: colors.darkGray,
      titleUnderlineColor: colors.gold,
      titleColor: "#373e47",
      mainVariant1: grey[300],
      mainVariant2: grey[400],
      mainVariant3: grey[500]
    },
    type: "light",
    primary: {
      light: "#3f4752",
      main: colors.black,
      dark: colors.duckBlue,
      contrastText: colors.lightblue
    },
    secondary: {
      light: colors.lightGray,
      main: colors.darkGray,
      dark: colors.black,
      contrastText: blue[200]
    },
    text: {
      primary: colors.black,
      secondary: colors.black,
      contrastText: colors.darkGray
    }
  },
  overrides: {
    // Header
    MuiAppBar: {
      root: {
        borderBottom: "none",
        fontSize: "12px",
        // Layout
        "& .MuiToolbar-root": {
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center"
        },
        // Tabs
        "& .MuiTabs-indicator": {
          display: "none"
        },
        "& .MuiTabs-root": {
          "& .MuiButtonBase-root:hover": {
            color: colors.white,
            backgroundColor: colors.darkblue
          }
        },
        // Logo
        "& .header-logo-wrapper": {
          display: "flex",
          alignItems: "center"
        },
        "& .header-logo": {
          width: "200px",
          marginRight: "40px",
          alignSelf: "center"
        },
        // User menu
        "& .header-admin-chip": {
          backgroundColor: colors.gold,
          color: colors.white,
          margin: "auto",
          fontWeight: "bold",
          marginRight: "12px"
        },
        "& .header-admin-chip:hover": {
          backgroundColor: colors.lightgold
        },
        "& .header-admin-chip .MuiChip-avatar": {
          color: colors.white,
          fill: colors.white
        },
        "& .header-user-profile": {
          backgroundColor: colors.duckBlue,
          color: colors.white,
          borderRadius: "5px",
          cursor: "pointer",
          padding: "4px 10px"
        },
        "& .header-user-profile:hover": {
          backgroundColor: colors.blue
        },
        "& .header-user-profile .MuiTypography-root": {
          color: colors.white,
          fontSize: "14px",
          paddingLeft: "20px"
        },
        "& .header-user-profile .MuiSvgIcon-root": {
          fill: colors.white
        }
      }
    },
    // Buttons
    MuiButton: {
      outlinedPrimary: {
        color: colors.black
      },
      containedPrimary: {
        backgroundColor: colors.darkblue,
        color: colors.white
      },
      containedSecondary: {
        color: colors.white
      }
    },
    MuiButtonGroup: {
      root: {
        // "& .MuiButtonBase-root": {
        //   borderColor: colors.darkblue,
        //   color: colors.darkblue
        // },
        // "& .MuiButtonBase-root:hover": {
        //   backgroundColor: colors.darkblue,
        //   borderColor: colors.darkblue,
        //   color: colors.white
        // "& .MuiSvgIcon-root": {
        //   fill: colors.white
        // }
        // }
      }
    },
    MuiFab: {
      // override default secondary color
      // see: src/component/withWidgetTogglePreview.jsx
      secondary: {
        backgroundColor: colors.duckBlue,
        color: colors.white
      }
    }
  }
}

const tableTheme = {
  ...appTheme,
  overrides: {
    MuiTableBody: {
      root: {
        "& span": {
          color: colors.black
        }
      }
    },

    MUIDataTable: {
      root: {},
      paper: {
        borderRadius: 2,
        maxWidth: "100%",
        boxSizing: "border-box"
      }
    },
    MUIDataTableToolbarSelect: {
      root: {
        paddingLeft: "24px",
        paddingRight: "24px"
      },
      title: {
        paddingLeft: 0
      }
    },
    // table header
    MUIDataTableHeadRow: {
      root: {
        textAlign: "left",
        color: colors.lightgold,
        "& th": {
          backgroundColor: colors.darkGray,
          borderRight: `1px solid${colors.lightgold}`,
          padding: "6px 24px 6px 16px",
          "& p": {
            fontSize: "0.875rem",
            padding: 0,
            fontWeight: "bold"
          },
          "& div": {
            fontSize: "12px",
            fontWeight: "bold",
            color: colors.lightgold
          }
        },
        "& th:last-child": {
          borderRight: `0px`
        }
      }
    },
    // each cell
    MUIDataTableHeadCell: {
      // sortActive: {
      //   fontWeight: 'bold',
      //   color: appTheme.palette.secondary.main,
      // },
      sortAction: {
        '& svg[class*="MuiTableSortLabel"]': {
          color: `${colors.lightgold}!important`,
          fontSize: "14px"
        }
      }
    },
    // body cells
    MUIDataTableBodyRow: {
      root: {
        "& td": {
          fontSize: "0.75rem",
          padding: "4px 8px",
          borderRight: `1px solid ${colors.lightgold}`,
          borderLeft: `1px solid ${colors.lightgold}`
        }
      }
    },
    // Checkboxes cells
    MuiCheckbox: {
      root: {
        color: colors.gold,
        "&.Mui-checked": {
          color: `${colors.gold}!important`
        }
      }
    }
  }
}

const widgetTableTheme = null

export { appTheme, tableTheme, widgetTableTheme }
